import chatIcon from "../images/gbs-connect-ico.png";

const chatIconUrl = chatIcon || "/_assets/gbs-connect-ico.png";

function createChatWidget() {
  if (document.getElementById("plai-chat-container")) return;

  const container = document.createElement("div");
  container.id = "plai-chat-container";
  container.innerHTML = `
    <!-- Teaser / Globo flotante de notificación -->
    <div id="plai-chat-teaser" class="chat-teaser" style="display: none;">
      <span class="teaser-badge">1</span>
      <div class="teaser-text">¡Hola! Soy GBS Connect, tu asistente inteligente. ¿En qué puedo ayudarte hoy?</div>
    </div>

    <!-- Botón Flotante -->
    <button id="plai-chat-toggle" class="chat-toggle-btn" title="Chatear con GBS Connect">
      <img src="${chatIconUrl}" onerror="this.onerror=null;this.src='/_assets/gbs-connect-ico.png';" alt="GBS Connect" />
    </button>

    <!-- Ventana de Chat -->
    <div id="plai-chat-window" class="chat-window">
      <div class="chat-header">
        <div class="chat-header-title">GBS Connect</div>
        <button id="plai-chat-close" class="chat-close-btn">&times;</button>
      </div>
      <div id="plai-chat-messages" class="chat-messages"></div>
      <div id="plai-chat-file-preview" class="chat-file-preview" style="display: none;"></div>
      <div class="chat-input-area">
        <textarea id="plai-chat-input" placeholder="Pregunta algo al agente..." rows="1"></textarea>
        <button id="plai-chat-send" class="chat-send-btn" title="Enviar">
          ➤
        </button>
      </div>
    </div>
  `;
  document.body.appendChild(container);

  // Enlazar los eventos inmediatamente después de crear los elementos
  bindChatEvents();

  // Programar la notificación emergente a los 3 segundos
  scheduleAutoGreeting();
}

function initializePlaiChat() {
  // Inicializar ID de conversación en sessionStorage (muere al cerrar la pestaña)
  let sessionId = sessionStorage.getItem("plai_chat_session_id");
  if (!sessionId) {
    sessionId =
      "session_" +
      Math.random().toString(36).substring(2, 15) +
      "_" +
      Date.now();
    sessionStorage.setItem("plai_chat_session_id", sessionId);
  }

  // Crear la estructura de la interfaz de chat en el DOM
  createChatWidget();
}

function bindChatEvents() {
  const chatToggle = document.getElementById("plai-chat-toggle");
  const chatWindow = document.getElementById("plai-chat-window");
  const closeBtn = document.getElementById("plai-chat-close");
  const sendBtn = document.getElementById("plai-chat-send");
  const inputField = document.getElementById("plai-chat-input");
  const messagesContainer = document.getElementById("plai-chat-messages");

  if (!chatToggle || !chatWindow || !closeBtn || !sendBtn || !inputField)
    return;

  // Abrir / Cerrar Chat
  const openChat = () => {
    const teaser = document.getElementById("plai-chat-teaser");
    if (teaser) teaser.style.display = "none";
    chatWindow.classList.add("active");
    chatToggle.classList.add("hidden");
    inputField.focus();
    // Mensaje de bienvenida inicial si está vacío
    if (messagesContainer.children.length === 0) {
      addMessage(
        "agent",
        "¡Hola! Soy GBS Connect, tu asistente inteligente. ¿En qué puedo ayudarte hoy?."
      );
      addFaqSuggestions(inputField, messagesContainer);
    }
  };

  chatToggle.addEventListener("click", openChat);

  const teaser = document.getElementById("plai-chat-teaser");
  if (teaser) {
    teaser.addEventListener("click", openChat);
  }

  closeBtn.addEventListener("click", () => {
    chatWindow.classList.remove("active");
    chatToggle.classList.remove("hidden");
  });

  // Enviar mensaje al presionar Enter (sin Shift)
  inputField.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage(inputField, messagesContainer);
    }
  });

  sendBtn.addEventListener("click", () =>
    sendMessage(inputField, messagesContainer),
  );
}

function addMessage(sender, text, messagesContainer) {
  const container =
    messagesContainer || document.getElementById("plai-chat-messages");
  if (!container) return;

  const contentText =
    typeof text === "string" ? text : text ? String(text) : "";
  if (!contentText.trim()) return;

  const messageElement = document.createElement("div");
  messageElement.classList.add("chat-message", sender);

  const bubble = document.createElement("div");
  bubble.classList.add("message-bubble");
  bubble.innerText = contentText;

  messageElement.appendChild(bubble);
  container.appendChild(messageElement);
  container.scrollTop = container.scrollHeight;
}

function addLoadingIndicator(messagesContainer) {
  const container =
    messagesContainer || document.getElementById("plai-chat-messages");
  if (!container) return;

  removeLoadingIndicator();

  const loadingElement = document.createElement("div");
  loadingElement.id = "plai-chat-loading";
  loadingElement.classList.add("chat-message", "agent");

  loadingElement.innerHTML = `
    <div class="message-bubble chat-loading">
      <span></span><span></span><span></span>
    </div>
  `;
  container.appendChild(loadingElement);
  container.scrollTop = container.scrollHeight;
}

function removeLoadingIndicator() {
  const loadingElement = document.getElementById("plai-chat-loading");
  if (loadingElement) {
    loadingElement.remove();
  }
}

function addFaqSuggestions(inputField, messagesContainer) {
  const container =
    messagesContainer || document.getElementById("plai-chat-messages");
  if (!container) return;

  const faqs = [
    "📝 ¿Cómo realizo mi registro inicial en el portal?",
    "📋 ¿Qué requisitos se necesitan para postular?"
  ];

  const faqContainer = document.createElement("div");
  faqContainer.classList.add("chat-faq-container");

  faqs.forEach((question) => {
    const chip = document.createElement("button");
    chip.classList.add("faq-chip");
    chip.innerText = question;
    chip.addEventListener("click", () => {
      inputField.value = question;
      sendMessage(inputField, container);
    });
    faqContainer.appendChild(chip);
  });

  container.appendChild(faqContainer);
  container.scrollTop = container.scrollHeight;
}

async function sendMessage(inputField, messagesContainer) {
  const text = inputField.value.trim();
  if (!text) return;

  const faqContainer = document.querySelector(".chat-faq-container");
  if (faqContainer) faqContainer.remove();

  // Mostrar mensaje en la interfaz
  addMessage("user", text, messagesContainer);
  inputField.value = "";

  addLoadingIndicator(messagesContainer);

  const sessionId = sessionStorage.getItem("plai_chat_session_id");
  const formData = new FormData();
  formData.append("message", text);
  formData.append("session_id", sessionId);

  try {
    const response = await fetch("/api/v2/chat/message", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    removeLoadingIndicator();

    if (response.ok) {
      addMessage("agent", data.response, messagesContainer);
    } else {
      addMessage(
        "agent",
        `Error: ${data.error || "No se pudo comunicar con el agente RAG."}`,
        messagesContainer,
      );
    }
  } catch (err) {
    removeLoadingIndicator();
    addMessage(
      "agent",
      "Error de red: No se pudo conectar al servidor de chat.",
      messagesContainer,
    );
    console.error(err);
  }
}

function scheduleAutoGreeting() {
  // Solamente ejecutar la animación automática si no ha abierto la ventana
  setTimeout(() => {
    const chatWindow = document.getElementById("plai-chat-window");
    const teaser = document.getElementById("plai-chat-teaser");
    
    // Si la ventana aún no está activa, mostrar la notificación y abrir el chat de inmediato
    if (chatWindow && !chatWindow.classList.contains("active")) {
      if (teaser) {
        teaser.style.display = "flex";
        teaser.classList.add("show-teaser");
      }
      
      // Tras mostrar el aviso visual por un instante corto (ej. 800ms para efecto de llegada), abrir el chat
      setTimeout(() => {
        const toggleBtn = document.getElementById("plai-chat-toggle");
        if (toggleBtn && !chatWindow.classList.contains("active")) {
          toggleBtn.click();
        }
      }, 800);
    }
  }, 3000);
}

// Inicializar al cargar la página
// NOTA: Se desconectó chat en producción
// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", initializePlaiChat);
// } else {
//   initializePlaiChat();
// }
// document.addEventListener("turbolinks:load", initializePlaiChat);

